<button mat-icon-button [matMenuTriggerFor]="accountMenu" i18n-aria-label aria-label="Account Menu">
  @if (roles.includes('student')) {
    <mat-icon>account_circle</mat-icon>
  } @else {
    <mat-icon>account_box</mat-icon>
  }
</button>
<mat-menu #accountMenu="matMenu" xPosition="before">
  <div class="header-account-menu">
    @if (!roles.includes('surveyStudent')) {
      <div class="user-info flex flex-row items-center space-x-2">
        @if (roles.includes('student')) {
          <mat-icon i18n-aria-label aria-label="Account avatar">account_circle</mat-icon>
        } @else {
          <mat-icon i18n-aria-label aria-label="Account avatar">account_box</mat-icon>
        }
        <span>{{ firstName }} {{ lastName }}</span>
      </div>
      @if (isPreviousAdmin) {
        <div class="user-switch">
          <a (click)="switchToOriginalUser()" i18n>Switch back to original user</a>
        </div>
      }
      <mat-divider />
      @if (roles.includes('student')) {
        <a
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          mat-menu-item
          routerLink="/student"
        >
          <mat-icon>home</mat-icon>
          <span i18n>Student Home</span>
        </a>
      }
      @if (roles.includes('teacher')) {
        <a
          mat-menu-item
          routerLink="/teacher"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon>home</mat-icon>
          <span i18n>Teacher Home</span>
        </a>
      }
      @if (roles.includes('student')) {
        <a
          mat-menu-item
          routerLink="/student/profile/edit"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon>edit</mat-icon>
          <span i18n>Edit Profile</span>
        </a>
      }
      @if (roles.includes('teacher')) {
        <a
          mat-menu-item
          routerLink="/teacher/profile/edit"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon>edit</mat-icon>
          <span i18n>Edit Profile</span>
        </a>
      }
      @if (roles.includes('researcher')) {
        <a mat-menu-item (click)="switchToAdmin()">
          <mat-icon>settings</mat-icon>
          <span i18n>Researcher Tools</span>
        </a>
      }
      @if (roles.includes('admin')) {
        <a mat-menu-item (click)="switchToAdmin()">
          <mat-icon>settings</mat-icon>
          <span i18n>Admin Tools</span>
        </a>
      }
      <a
        mat-menu-item
        routerLink="/help"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon>help</mat-icon>
        <span i18n>Help</span>
      </a>
      <mat-divider></mat-divider>
    }
    <a mat-menu-item (click)="logOut()">
      <mat-icon color="warn">exit_to_app</mat-icon>
      <span class="warn" i18n>Sign Out</span>
    </a>
  </div>
</mat-menu>
